import { render, staticRenderFns } from "./SeccionEnlaces.vue?vue&type=template&id=5b86c600&scoped=true"
import script from "./SeccionEnlaces.vue?vue&type=script&lang=js"
export * from "./SeccionEnlaces.vue?vue&type=script&lang=js"
import style0 from "./SeccionEnlaces.vue?vue&type=style&index=0&id=5b86c600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b86c600",
  null
  
)

export default component.exports